import { Input } from "@dune/ui";
import { useMemo } from "react";

type RateInputProps = {
	value: string | undefined;
	onChange: (next: string) => void;
	placeholder?: string;
	disabled?: boolean;
	iconOrText?: React.ReactNode | string;
	iconOrTextPosition?: "left" | "right";
	decimals?: number;
};

const normalize = (v: string) => v.replace(/\u00A0|\u202F/g, " ").trim();

// Même logique que PriceInput mais représente un pourcentage en string, affiché multiplié par 100 côté UI
const sanitizeRate = (raw: string, decimals: number): string => {
	let v = normalize(raw).replace(/\s/g, "");
	v = v.replace(/,/g, ".");
	v = v.replace(/[^\d.]/g, "");
	const parts = v.split(".");
	if (parts.length > 2) {
		v = `${parts[0]}.${parts.slice(1).join("")}`;
	}
	const [intPart, decPart] = v.split(".");
	const intClean = (intPart || "").replace(/^0+(?=\d)/, "0");
	const decClean = (decPart || "").slice(0, decimals);
	return decClean.length > 0 ? `${intClean}.${decClean}` : intClean;
};

export const RateInput = ({
	value,
	onChange,
	placeholder,
	disabled,
	iconOrText,
	iconOrTextPosition = "right",
	decimals = 2,
}: RateInputProps) => {
	const display = useMemo(() => value ?? "", [value]);
	return (
		<Input
			inputMode="decimal"
			placeholder={placeholder ?? `0,${"0".repeat(decimals)}`}
			value={display}
			onChange={(e) => onChange(sanitizeRate(e.target.value, decimals))}
			disabled={disabled}
			iconOrText={iconOrText}
			iconOrTextPosition={iconOrTextPosition}
		/>
	);
};

export const parseRateStringToFraction = (
	s: string | undefined | null,
): number | null => {
	if (!s) return null;
	const normalized = s.replace(/\s/g, "").replace(/,/g, ".");
	const num = Number(normalized);
	if (Number.isNaN(num)) return null;
	return num / 100; // UI en %, backend en fraction
};
